import { useSelector } from 'react-redux'
import Menu from '../../atoms/navigation/Menu'
import MenuItem from '../../atoms/navigation/MenuItem'
import Divider from '../../atoms/display/Divider'
import {
  AccountsIcon,
  AgreementIcon,
  ApprovalFlowIcon,
  ClientIcon,
  CompanyIcon,
  JobIcon,
  LogoutIcon,
  SettingsIcon,
} from '../../atoms/display/Icons'
import { CompanySelectors } from '../../../store/company/selectors'
import Chip from '../../atoms/display/Chip'
import useConfig from '../../../hooks/useConfig'
import useAgreements from '../../../hooks/useAgreements'
import { SessionSelectors } from '../../../store/session/selectors'

type AccountMenuProps = {
  target?: Element
  onClose: () => void
  onLogout: () => void
  onSettingsCompany: () => void
  onSettingsUsers: () => void
  onSettingsClients: () => void
  onSettingsProfile: () => void
  onSettingsApprovalFlows: () => void
  onAgreements: () => void
  onSettingsJob: () => void
}

export default function AccountMenu({
  target,
  onClose,
  onLogout,
  onSettingsCompany,
  onSettingsUsers,
  onSettingsClients,
  onSettingsProfile,
  onSettingsApprovalFlows,
  onAgreements,
  onSettingsJob,
}: AccountMenuProps) {
  const user = useSelector(SessionSelectors.user)
  const agreements = useAgreements()
  const countInvitations = useSelector(CompanySelectors.countInvitations)
  const isSubmittedIdentity = useSelector(CompanySelectors.isSubmittedIdentity)
  const companyAgreementCount = agreements.getUnconfirmCompanyAgreements(user?.id ?? '').length
  const { enableJob } = useConfig()
  const handleSelectItem = (callback: () => void) => () => {
    callback()
    onClose()
  }

  return (
    <Menu target={target} onClose={onClose}>
      <MenuItem
        icon={<CompanyIcon />}
        label="企業情報管理"
        right={isSubmittedIdentity === false ? <Chip label="1" color="error" size="small" /> : undefined}
        onClick={handleSelectItem(onSettingsCompany)}
      />
      <MenuItem icon={<AccountsIcon />} label="ユーザー管理" onClick={handleSelectItem(onSettingsUsers)} />
      <MenuItem
        icon={<ClientIcon />}
        label="取引先管理"
        right={countInvitations > 0 ? <Chip label={countInvitations} color="error" size="small" /> : undefined}
        onClick={handleSelectItem(onSettingsClients)}
      />
      <MenuItem
        icon={<ApprovalFlowIcon />}
        label="承認フロー設定"
        onClick={handleSelectItem(onSettingsApprovalFlows)}
      />
      <MenuItem
        icon={<AgreementIcon />}
        label="契約管理"
        right={
          companyAgreementCount > 0 ? <Chip label={companyAgreementCount} color="error" size="small" /> : undefined
        }
        onClick={handleSelectItem(onAgreements)}
      />
      {enableJob && (
        <>
          <Divider />
          <MenuItem icon={<JobIcon />} label="求人管理" onClick={handleSelectItem(onSettingsJob)} />
        </>
      )}
      <Divider />
      <MenuItem icon={<SettingsIcon />} label="個人設定" onClick={handleSelectItem(onSettingsProfile)} />
      <Divider />
      <MenuItem icon={<LogoutIcon />} label="ログアウト" onClick={onLogout} />
    </Menu>
  )
}
